export const getModalViews = state => state.ui.modal.views;
